import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLenis } from './SmoothScroll';

const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  const { lenis } = useLenis();

  useLayoutEffect(() => {
    // Reset both the native scroll position and Lenis-managed scroll on route changes.
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    if (lenis) {
      lenis.scrollTo(0, { immediate: true });
    }
  }, [pathname, search, lenis]);

  return null;
};

export default ScrollToTop;
